<template>
    <span class="lds-widget-card__usp">{{ advantage }}</span>
</template>

<script setup>
/* утп - желтая плашка */
defineProps({
    advantage: {
        type: String,
        required: true,
    },
});
</script>